import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {BaseComponent} from "../../base.component";

@Component({
  selector: 'app-frontend-star-rate',
  standalone: false,
  templateUrl: './frontend-star-rate.component.html',
  styleUrls: ['./frontend-star-rate.component.scss']
})
export class FrontendStarRateComponent extends BaseComponent implements OnInit {
  stars: number[] = [1, 2, 3, 4, 5];
  @Input()
  userRate: number = 0;
  @Output()
  userRateChange: EventEmitter<number> = new EventEmitter<number>();
  currentRate: number = 0;
  protected readonly Math = Math;

  constructor(private injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    this.currentRate = this.userRate || 0;
  }

  rate(rate: number): void {
    this.currentRate = rate;
    this.userRate = rate;
    this.userRateChange.emit(this.currentRate);
  }
}
